import React from "react";
import { Loader2 } from "lucide-react";

const BackdropLoading = () => (
	<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs">
		<Loader2 className="h-8 w-8 animate-spin text-white" />
		<span className="sr-only">Carregando…</span>
	</div>
);

export default BackdropLoading;
